import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from '../../../hooks/useAuth';
import Login from '../../../pages/auth/Login';
import LoadingPage from '../../LoadingPage/LoadingPage';
import AccountOnHold from '../../../pages/error/AccountOnHold';

const AuthGuard = (props) => {
  const { children } = props;
  const { isAuthenticated, isValidatingToken, isClientOnHold } = useAuth();
  const location = useLocation();
  const [requestedLocation, setRequestedLocation] = useState(null);

  if (!isAuthenticated) {
    if (location.pathname !== requestedLocation) {
      setRequestedLocation(location.pathname);
    }

    if (isValidatingToken) {
      return <LoadingPage />;
    }

    return <Login />;
  }

  if (isClientOnHold) {
    return <AccountOnHold />;
  }

  // This is done so that in case the route changes by any chance through other
  // means between the moment of request and the render we navigate to the initially
  // requested route.
  if (requestedLocation && location.pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
};

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default AuthGuard;
